import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const RegistrarActividad = () => {
  const { id } = useParams(); // ID de la matrícula
  const navigate = useNavigate();

  // Estados individuales
  const [nombreActividad, setNombreActividad] = useState('');

  const [descripcion, setDescripcion] = useState('');
  const [fecha] = useState(() => {
    const hoy = new Date();
    const year = hoy.getFullYear();
    const month = String(hoy.getMonth() + 1).padStart(2, '0');
    const day = String(hoy.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  });

  const cleanData = () => {
    setNombreActividad('');
    setDescripcion('');
  };

  const handleCancelar = () => {
    cleanData();
    navigate('/matricula/listarmatriculas');
  };

  // Guardar actividad
  const saveActividad = async () => {
    try {
      const newActividad = {
        nombreActividad,
        fecha,
        descripcion,
      };

      const res = await axios.post(`/api/actividad/add/${id}`, newActividad);
      cleanData();
      Swal.fire({
        icon: 'success',
        title: 'Actividad registrada',
        text: res.data.mensaje,
        timer: 2000,
        showConfirmButton: false,
      });

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error al registrar',
        text: error.response?.data?.error || error.message,
      });
    }
  };

  const actions = async (e) => {
    e.preventDefault();
    await saveActividad();
  };



  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
      < div className='container-fluid mt-3' >
        <h1>Registrar Actividad</h1>
      </div>

      <div className='mb-5'>

        <form onSubmit={actions}>

          <div className="container">

            <div className="row mb-3 mt-3">
              <div className="col-12 col-md-9 mb-3 mb-md-0">
                <label className="form-label">Nombre de la Actividad</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  value={nombreActividad}
                  onChange={(e) => setNombreActividad(e.target.value)}
                />
              </div>

              <div className="col-12 col-md-3">
                <label className="form-label">Fecha</label>
                <input
                  type="date"
                  className="form-control"
                  value={fecha}
                  readOnly
                />
              </div>

              <div className="col-12 mt-3">
                <label className="form-label">Descripción de la Actividad</label>
                <textarea
                  className="form-control"
                  rows={3}
                  required
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                />
              </div>
            </div>

            {/* Botón de envío */}
            <div className="col-12 mt-4 mb-5">
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <button type="submit" className="btn btn-success w-100">
                    Enviar
                  </button>
                </div>
                <div className="col-12 col-md-6">
                  <button type="button"
                    className="btn btn-danger w-100"
                    onClick={handleCancelar}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>
  );
};

export default RegistrarActividad;
